import { render } from "./BarMaxValue.vue?vue&type=template&id=81b67dd2&scoped=true"
import script from "./BarMaxValue.vue?vue&type=script&lang=js"
export * from "./BarMaxValue.vue?vue&type=script&lang=js"

import "./BarMaxValue.vue?vue&type=style&index=0&id=81b67dd2&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81b67dd2"]])

export default __exports__